import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import { Module, Action, VuexModule } from 'vuex-module-decorators';

export interface MethodologyObject {
  id: number;
  type: number;
  key: string;
  titleEn: string;
  titleAr: string;
  htmlEn: string;
  htmlAr: string;
  htmlEnWeb: string;
  htmlArWeb: string;
  sort: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

@Module
export default class MethodologyModule extends VuexModule {
  errors = {};

  @Action
  [Actions.GET_METHODOLOGIES](type: number) {
    ApiService.setAuthorizationHeader();
    return ApiService.query('/indices/methodology', {
      params: { type, limit: 100 },
    });
  }

  @Action
  [Actions.GET_METHODOLOGY](id: number) {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/indices/methodology', `${id}`);
  }

  @Action
  [Actions.UPDATE_METHODOLOGY]({ id, data }) {
    ApiService.setAuthorizationHeader();
    return ApiService.update('/indices/methodology', `${id}`, data).catch(
      ({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      }
    );
  }

  @Action
  [Actions.GET_METHODOLOGY_DETAILED](key: string) {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/indices/methodology/detailed', key);
  }

  @Action
  [Actions.UPDATE_METHODOLOGY_DETAILED]({ key, data }) {
    ApiService.setAuthorizationHeader();
    return ApiService.update('/indices/methodology/detailed', key, data).catch(
      ({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      }
    );
  }
}
